/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".msg[_ngcontent-%COMP%]{padding:10px 20px;margin-bottom:10px}.ng-invalid.ng-touched[_ngcontent-%COMP%]{border-color:red}\n/*# sourceMappingURL=enriquecimentos.component.css.map*/"];
export { styles as styles };
